import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Button,
  IconButton,
  useTheme,
} from "@mui/material";
import Exclamation from "../../../../assets/Exclamation.png";
import Redhat_light from "../../../../assets/redhat_light.svg"
import Redhat_dark from "../../../../assets/redhat_dark.svg"
import ubuntu from "../../../../assets/ubuntu_white.svg";
import windows_light from "../../../../assets/baseVersion/Windows_light.svg"
import windows_dark from "../../../../assets/baseVersion/Windows_dark.svg"
import ubuntu_dark from "../../../../assets/ubuntu_dark.svg";
import debian from "../../../../assets/debian.svg";
import debian_dark from "../../../../assets/debian_dark.svg";
import huawei_light from "../../../../assets/huawei-ar21 1.svg";
import huawei_dark from "../../../../assets/huawei-dark.svg";
import mikrotik from "../../../../assets/mikrotik.svg";
import mikrotik_dark from "../../../../assets/mikrotik_dark.svg";
import edgecore_logo from "../../../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../../../assets/apple.svg";
import apple_dark from "../../../../assets/apple_dark.svg";
import dell_logo from "../../../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../../../assets/syrotech_light.svg";
import syrotech_dark from "../../../../assets/syrotech_dark.svg";
import juniper from "../../../../assets/juniper.svg";
import juniper_dark from "../../../../assets/juniper_dark.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Cisco_img from "../../../../assets/baseVersion/cisco.svg";
import Paloalto_img from "../../../../assets/baseVersion/paloalto.svg";
import Paloalto_dark from "../../../../assets/palaoto_dark.svg";
import arista_img from "../../../../assets/baseVersion/arista.svg";
import arista_dark from "../../../../assets/arista_dark.svg";
import AWS_img from "../../../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../../../assets/baseVersion/AWS_DARK.svg"
import axiosInstance from "../../../../axios/axios";
import ReactJson from 'react-json-view';
import XMLViewer from 'react-xml-viewer';
import Right_Tick_img from "../../../../assets/baseVersion/Config_Tick_img.svg"
import Cancel_Icon from "../../../../assets/baseVersion/Config_Cancel_img.svg"
import Not_Applicable from "../../../../assets/baseVersion/NotApplicable.svg";
import WhiteTooltip from "../../../../components/WhiteTooltip";

interface LogoutputProps {
  status: "Fail" | "Pass";
  acceptedRisk: boolean;
  lastScanned: string;
  rowData: any;
  parameter_name_id: string;
  onBack?: () => void;
  parameterType?: string;
}

const Logoutput: React.FC<LogoutputProps> = ({
  // status,
  // acceptedRisk,
  // lastScanned,
  rowData,
  parameter_name_id,
  onBack,
  parameterType,
}) => {
  const isTemplate =
    parameterType?.toLowerCase() === "template" ||
    parameterType?.toLowerCase() === "custom";
  const [output, setOutput] = useState<any[]>([]);
  const [lastscanned, setLastScaneed] = useState()

  const [expanded, setExpanded] = useState<boolean[]>([]);
  const [proofExpanded, setProofExpanded] = useState<boolean[]>([]);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const module =
    String(rowData?.vendor ?? "").toLowerCase() === "amazon web services"
      ? "cloud"
      : "on_premise";



  let imgSrc = "";
  if (rowData.vendor === "cisco") {
    imgSrc = Cisco_img;
  } else if (rowData.vendor === "paloalto" || rowData.vendor === "Palo Alto" || rowData.vendor === "palo alto") {
    imgSrc = isDarkMode ? Paloalto_dark : Paloalto_img;
  } else if (rowData.vendor === "amazon web services") {
    imgSrc = isDarkMode ? AWS_DARK : AWS_img;
  } else if (rowData.vendor === "arista") {
    imgSrc = isDarkMode ? arista_dark : arista_img;
  }
  else if (rowData.vendor === "juniper") {
    imgSrc = isDarkMode ? juniper_dark : juniper;
  }
  else if (rowData.vendor === "ubuntu") {
    imgSrc = isDarkMode ? ubuntu_dark : ubuntu;
  }
  else if (rowData.vendor === "redhat") {
    imgSrc = isDarkMode ? Redhat_dark : Redhat_light;
  }
  else if (rowData.vendor === "microsoft") {
    imgSrc = isDarkMode ? windows_dark : windows_light;
  }
  else if (rowData.vendor === "debian") {
    imgSrc = isDarkMode ? debian_dark : debian;
  }
  else if (rowData.vendor === "huawei") {
    imgSrc = isDarkMode ? huawei_dark : huawei_light;
  }
  else if (rowData.vendor === "mikrotik") {
    imgSrc = isDarkMode ? mikrotik_dark : mikrotik;
  }
  else if (rowData.vendor === "edgecore") {
    imgSrc = edgecore_logo;
  }
  else if (rowData.vendor === "tp-link" || rowData.vendor === "tplink") {
    imgSrc = isDarkMode ? tplink_dark : tplink_light;
  }
  else if (rowData.vendor === "apple" || rowData.vendor === "macos") {
    imgSrc = isDarkMode ? apple_dark : apple_img;
  }
  else if (rowData.vendor === "dell") {
    imgSrc = dell_logo;
  }
  else if (rowData.vendor === "syrotech") {
    imgSrc = isDarkMode ? syrotech_dark : syrotech_light;
  }

  const handleToggle = (idx: number) => {
    setExpanded((prev) => prev.map((val, i) => (i === idx ? !val : val)));
  };

  const handleCollapseAll = () => {
    setExpanded(output.map(() => false));
    setProofExpanded(output.map(() => false));
  };

  const handleExpandAll = () => {
    setExpanded(output.map(() => true));
    setProofExpanded(output.map(() => true));
  };

  useEffect(() => {
    const fetchAssets = async () => {
      // setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `securityscan/scan-summary-device?device_id=${rowData.device_id}&parameter_name_id=${parameter_name_id}`
        );
        const scanDetails = response.data.data?.scan_details || [];
        setOutput(scanDetails);
        setLastScaneed(response?.data?.data?.last_scanned)

        setExpanded(scanDetails.map(() => true));
        setProofExpanded(scanDetails.map(() => true));
      } catch (error) {
        console.error("Error fetching scan details:", error);
      } finally {
        // setIsLoading(false);
      }
    };

    if (rowData.device_id) {
      fetchAssets();
    }
  }, [rowData.device_id, parameter_name_id]);

  return (
    <Box
      sx={{
        p: 3,
        width: "100%",
        maxWidth: 800,
        // backgroundColor: "#f9f9f9",
        borderRadius: 2,
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",

      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          flexDirection: "row",
          pl: 0
        }}
      >
        {onBack && (
          <IconButton onClick={onBack} sx={{ mr: 1, pl: 0 }}>
            <ArrowBackIcon />
          </IconButton>
        )}
        {rowData?.hostname && (
          <Typography variant="h6" sx={{ fontWeight: 700, mr: 2 }}>
            <span>
              {rowData.hostname}(
              {imgSrc && (
                <img
                  src={imgSrc}
                  alt={rowData.vendor}
                  style={{ width: 40, height: 20, marginRight: 1, marginLeft: 1 }}
                />
              )}
              )
            </span>
          </Typography>
        )}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: 12,
              color: "#8480AD",
            }}
          >
            Status:
          </Typography>
          {/* <Chip
              label={!rowData.compliance ? "Fail" : "Success"}
              color={!rowData.compliance ? "error" : "success"}
              sx={{
                fontWeight: 700,
                fontSize: 12,
                height: 28,
                borderRadius: 1,
                width: "fit-content",
              }}
            /> */}
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8 }}>
            {rowData.compliance === "pass" ? (
              <img src={Right_Tick_img} alt="Success" />
            ) : rowData.compliance === "fail" ? (
              <img src={Cancel_Icon} alt="Fail" />
            ) : (
              <img src={Not_Applicable} alt="Not Applicable" />
            )}

            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {rowData.compliance === "pass"
                ? "Success"
                : rowData.compliance === "fail"
                  ? "Fail"
                  : "Not Applicable"}
            </Typography>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              ml: 3,
              fontSize: 12,
              color: "#8480AD",
            }}
          >
            Accepted Risk:
          </Typography>
          {isTemplate ? (
            <Typography variant="body2" sx={{ fontWeight: 600, ml: 3 }}>
              N/A
            </Typography>
          ) : rowData?.acceptedRisk ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
                marginLeft: 12,
              }}
            >
              <img
                src={Exclamation}
                alt="Accepted"
                style={{ width: 24, height: 24 }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Accepted
              </Typography>
            </div>
          ) : (
            <Typography variant="body2" sx={{ fontWeight: 600, ml: 3 }}>
              Not Accepted
            </Typography>
          )}
        </div>
        {lastscanned && (
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: 12,
                color: "#8480AD",
                ml: 3,
              }}
            >
              Last Scanned:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, ml: 3 }}>
              {new Date(lastscanned).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              }).replace(/ /g, ' ').replace(',', ',')}
            </Typography>
          </div>
        )}
      </Box>

      <Divider sx={{ mb: 3 }} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          gap: 2,
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Analysis
        </Typography>
        {expanded.every(Boolean) ? (
          <Button
            size="small"
            onClick={handleCollapseAll}
            variant="outlined"
          >
            Collapse All
          </Button>
        ) : (
          <Button
            size="small"
            onClick={handleExpandAll}
            variant="outlined"
          >
            Expand All
          </Button>
        )}
      </Box>
      {module == "on_premise" ? (
        <Box>
          {output.map((item, idx) => {
            console.log(item, "itemitemitem");
            const ruleName = item.RuleName || "Scan Analysis";
            const tests = Array.isArray(item.Tests)
              ? item.Tests
              : item.Tests && typeof item.Tests === "object"
              ? [item.Tests]
              : [];

            // Determine overall status for this specific analysis section
            const hasFailure =
              tests.length > 0
                ? tests.some(
                    (t: any) =>
                      String(t?.Status || t?.status || "").toUpperCase() === "FAILED" ||
                      t?.Status === false ||
                      t?.status === false
                  )
                : rowData.compliance === "fail" || rowData.compliance === false || rowData.compliance === 0;

            return (
              <Box
                key={idx}
                sx={{
                  mb: 2,
                  p: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  backgroundColor: isDarkMode ? "#1E1E1E" : "#F5F5F5",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "1rem",
                        color: hasFailure ? "#d32f2f" : "#388e3c",
                      }}
                    >
                      {ruleName}
                    </Typography>
                    {hasFailure ? (
                      <CancelIcon sx={{ color: "#d32f2f" }} fontSize="small" />
                    ) : (
                      <CheckCircleIcon color="success" fontSize="small" />
                    )}
                  </Box>
                  <IconButton size="small" onClick={() => handleToggle(idx)}>
                    {expanded[idx] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                {expanded[idx] && (
                  <Box sx={{ mt: 1, ml: 2 }}>
                    {(() => {
                      const isEndpoint = String(
                        (rowData?.resources_type ?? rowData?.resource_type ?? rowData?.resourcesType ?? "")
                      ).toUpperCase() === "ENDPOINT";

                      // Helper function to format XML content nicely
                      const formatXmlContent = (xmlString: string) => {
                        try {
                          // Add proper line breaks and indentation for XML
                          let formatted = xmlString
                            .replace(/></g, '>\n<')
                            .replace(/(<[^/][^>]*>)([^<]+)(<\/[^>]+>)/g, '$1\n  $2\n$3');

                          // Split by lines and indent properly
                          const lines = formatted.split('\n');
                          let indent = 0;
                          const formattedLines = lines.map(line => {
                            line = line.trim();
                            if (!line) return '';

                            // Decrease indent for closing tags
                            if (line.startsWith('</')) {
                              indent = Math.max(0, indent - 1);
                            }

                            const indentedLine = '  '.repeat(indent) + line;

                            // Increase indent for opening tags (not self-closing)
                            if (line.startsWith('<') && !line.startsWith('</') && !line.endsWith('/>') && !line.includes('</')) {
                              indent++;
                            }

                            return indentedLine;
                          });

                          return formattedLines.filter(l => l).join('\n');
                        } catch {
                          return xmlString;
                        }
                      };

                      // For ENDPOINT: Sort tests to show Reason first, then Proof, then Raw Evidence
                      const sortedTests = isEndpoint
                        ? [...tests].sort((a: any, b: any) => {
                          const order: Record<string, number> = { 'REASON': 1, 'PROOF': 2, 'RAW EVIDENCE': 3 };
                          const statusA = String(a.Status ?? a.status ?? '').toUpperCase();
                          const statusB = String(b.Status ?? b.status ?? '').toUpperCase();
                          return (order[statusA] ?? 99) - (order[statusB] ?? 99);
                        })
                        : tests;

                      // Track if we've already shown the Proof heading
                      let proofHeadingShown = false;

                      return sortedTests.map((test: any, testIdx: number) => {
                        const status = test.Status ?? test.status ?? "";
                        const desc = test.Description ?? test.description ?? "";
                        const statusUpper = String(status).toUpperCase();

                        // Special handling only for ENDPOINT resource type
                        if (isEndpoint) {
                          // Skip FAILED/PASSED/NOT APPLICABLE status items - don't render them (status already shown at top)
                          if (statusUpper === "FAILED" || statusUpper === "PASSED" || statusUpper === "PASS" || statusUpper === "FAIL" || statusUpper === "NOT APPLICABLE" || statusUpper === "NOT_APPLICABLE" || statusUpper === "N/A") {
                            return null;
                          }

                          // PROOF - Show Proof heading only once
                          if (statusUpper === "PROOF") {
                            // If we've already shown the heading, skip this item
                            if (proofHeadingShown) {
                              return null;
                            }

                            // Mark that we've shown the heading
                            proofHeadingShown = true;

                            return (
                              <Box key={testIdx} sx={{ mb: 1, mt: 1 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: "0.95rem",
                                    color: theme.palette.text.primary,
                                  }}
                                >
                                  Proof:
                                </Typography>
                              </Box>
                            );
                          }

                          // RAW EVIDENCE - Show in XML viewer without heading (displayed under Proof)
                          if (statusUpper === "RAW EVIDENCE") {
                            const xmlTheme = {
                              attributeKeyColor: isDarkMode ? "#9cdcfe" : "#994500",
                              attributeValueColor: isDarkMode ? "#ce9178" : "#1a1aa6",
                              tagColor: isDarkMode ? "#569cd6" : "#881280",
                              textColor: isDarkMode ? "#d4d4d4" : "#333",
                              separatorColor: isDarkMode ? "#808080" : "#333",
                              commentColor: isDarkMode ? "#6a9955" : "#236e25",
                              cdataColor: isDarkMode ? "#ce9178" : "#1a1aa6",
                            };
                            return (
                              <Box key={testIdx} sx={{ mb: 2 }}>
                                <Box
                                  sx={{
                                    backgroundColor: isDarkMode ? "#1e1e1e" : "#f8f8f8",
                                    border: `1px solid ${isDarkMode ? "#444" : "#ddd"}`,
                                    borderRadius: 1,
                                    p: 2,
                                    maxHeight: "400px",
                                    overflow: "auto",
                                  }}
                                >
                                  <XMLViewer
                                    xml={desc || "<empty/>"}
                                    theme={xmlTheme}
                                    collapsible
                                    indentSize={2}
                                  />
                                </Box>
                              </Box>
                            );
                          }

                          // REASON - Show Reason heading with description
                          if (statusUpper === "REASON") {
                            return (
                              <Box key={testIdx} sx={{ mb: 2, mt: 1 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: "0.95rem",
                                    color: theme.palette.text.primary,
                                    mb: 1,
                                  }}
                                >
                                  Reason:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: "0.875rem",
                                    pl: 1,
                                    lineHeight: 1.6,
                                  }}
                                >
                                  {desc || "-"}
                                </Typography>
                              </Box>
                            );
                          }

                          // Default fallback for endpoint with unknown status
                          return (
                            <Box key={testIdx} sx={{ mb: 1 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: theme.palette.text.primary,
                                  fontSize: "0.875rem",
                                }}
                              >
                                {status && <strong>{status}: </strong>}
                                {desc || "-"}
                              </Typography>
                            </Box>
                          );
                        }

                        // Non-ENDPOINT: Original display logic (status: description)
                        // Skip NOT APPLICABLE status items - status already shown at top
                        if (statusUpper === "Not Applicable" || statusUpper === "NOT_APPLICABLE" || statusUpper === "N/A") {
                          return null;
                        }

                        const deviationReason =
                          test["Deviation Reason"] ??
                          test["deviation_reason"] ??
                          test["DeviationReason"] ??
                          test["deviationReason"] ??
                          test["Deviation_Reason"];

                        const displayText = `${status ? status + ": " : ""}${desc}`;
                        const isFail = String(status).toUpperCase().includes("FAIL");
                        const textColor = isFail ? "#d32f2f" : "#388e3c";

                        return (
                          <Box key={testIdx} sx={{ mb: 1.5 }}>
                            <WhiteTooltip
                              title={displayText || "-"}
                              placement="bottom"
                              arrow
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  color: textColor,
                                  fontSize: "0.875rem",
                                  mb: deviationReason ? 0.5 : 0.5,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "600px",
                                  cursor: "pointer",
                                }}
                              >
                                {displayText || "-"}
                              </Typography>
                            </WhiteTooltip>
                            {deviationReason && (
                              <Box
                                sx={{
                                  mt: 0.5,
                                  mb: 0.5,
                                  pl: 1.5,
                                  borderLeft: `3px solid ${isFail ? "#d32f2f" : "#388e3c"}`,
                                  py: 0.5,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: 700,
                                    color: theme.palette.text.primary,
                                    display: "block",
                                    mb: 0.25,
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  Deviation Reason:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: "0.825rem",
                                    lineHeight: 1.5,
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {deviationReason}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        );
                      });
                    })()}
                    {(() => {
                      const itemDeviationReason =
                        item["Deviation Reason"] ??
                        item["deviation_reason"] ??
                        item["DeviationReason"] ??
                        item["deviationReason"];
                      const anyTestHasDeviation = tests.some(
                        (t: any) =>
                          t["Deviation Reason"] ||
                          t["deviation_reason"] ||
                          t["DeviationReason"] ||
                          t["deviationReason"]
                      );

                      if (itemDeviationReason && !anyTestHasDeviation) {
                        return (
                          <Box
                            sx={{
                              mt: 1,
                              mb: 0.5,
                              pl: 1.5,
                              borderLeft: `3px solid ${hasFailure ? "#d32f2f" : "#388e3c"}`,
                              py: 0.5,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 700,
                                color: theme.palette.text.primary,
                                display: "block",
                                mb: 0.25,
                                fontSize: "0.8rem",
                              }}
                            >
                              Deviation Reason:
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: theme.palette.text.secondary,
                                fontSize: "0.825rem",
                                lineHeight: 1.5,
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                              }}
                            >
                              {itemDeviationReason}
                            </Typography>
                          </Box>
                        );
                      }
                      return null;
                    })()}
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      ) : (
        <>
          {output.map((item, idx) => (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: "1rem" }}>
                  {"Reason:"}
                </Typography>
              </Box >
              <Typography variant="body2" sx={{ fontSize: "16px", mt: 2, fontWeight: 500 }}>
                {/* Cloud-only: backend sends one long Reason string; split on "." for readability. */}
                {(item?.Reason || "Cloud Scan Output")
                  .split(/\.\s*/)
                  .map((part) => part.trim())
                  .filter(Boolean)
                  .map((sentence, i) => (
                    <Box key={i} component="div" sx={{ mb: 0.75 }}>
                      {sentence.endsWith(".") ? sentence : `${sentence}.`}
                    </Box>
                  ))}
              </Typography>
              {(item.proof || item.Proof) && (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      paddingTop: 2,
                    }}
                  >
                    <Typography sx={{ fontWeight: 700, fontSize: "1rem" }}>
                      {"Proof:"}
                    </Typography>
                  </Box>

                  <div style={{ marginTop: "16px", marginBottom: "16px", width: "105%" }}>
                    <Box sx={{
                      mt: 4,
                      p: 3,
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      backgroundColor: isDarkMode ? "#1E1E1E" : "#F5F5F5",
                      maxHeight: "500px",
                      overflow: "auto",
                    }}>
                      <ReactJson
                        src={item.Proof || item.proof}
                        name={false}
                        theme={isDarkMode ? "monokai" : "rjv-default"}
                        collapsed={!proofExpanded[idx]}
                        enableClipboard={false}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        displayArrayKey={false}
                      />
                    </Box>
                  </div>
                </>
              )}
            </>
          ))}
        </>
      )}


    </Box>
  );
};

export default Logoutput;
